window.homePanels = {"Stills" : 1, "About" : 2, "Motion" : 3}
// window.menuItems = {"Home" : 0, ...window.homePanels, "Shop": 4} // Shop tab
window.menuItems = {"Home" : 0, ...window.homePanels} // No shop tab
